/**
 * Green Flag — RegisteredEventBar
 *
 * The event page's pinned bottom bar once the viewer holds a seat: in place
 * of "Get Tickets", the one thing to do next from anywhere on the page.
 * Before the last few hours that is Sparking who's going (when anyone is
 * left to see), and otherwise nothing: the check-in code is not shown that
 * early. In the last few hours it is the check-in code.
 */

import { Box, Button, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { PinnedBottomBar } from "../PinnedBottomBar/PinnedBottomBar";
import { Icon } from "../Icon/Icon";

export interface RegisteredEventBarProps {
  /** "Sat, Oct 18 · 7:00 PM", already formatted. */
  when: string;
  /** When set (the last few hours), the bar's button shows the check-in code. */
  onShowCheckInCode?: () => void;
  /** When set, the bar's button opens the event's pre-event deck instead. */
  onStartSparking?: () => void;
}

export function RegisteredEventBar({
  when,
  onShowCheckInCode,
  onStartSparking,
}: RegisteredEventBarProps) {
  const action = onStartSparking
    ? {
        onClick: onStartSparking,
        icon: <Icon name="heart" boxSize="16px" />,
        label: "Start Sparking",
      }
    : onShowCheckInCode
      ? {
          onClick: onShowCheckInCode,
          icon: <FontAwesomeIcon icon={faQrcode} />,
          label: "Check-in code",
        }
      : null;
  return (
    <PinnedBottomBar>
      <Box>
        <Text textStyle="labelStrong">You're going</Text>
        <Text textStyle="caption" color="fg.muted">
          {when}
        </Text>
      </Box>
      {action && (
        <Button
          variant="solid"
          colorPalette="greenLight"
          size="lg"
          px="1.5rem"
          onClick={action.onClick}
        >
          {action.icon}
          {action.label}
        </Button>
      )}
    </PinnedBottomBar>
  );
}
